import './update_serv_modal.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import swal from 'sweetalert';
import { Row, InputGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from '@mui/material/Backdrop';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';

import { update_service_req } from '../../../../services/company_admin_service';


//////////////////////////////
/////////////email validation
function invalid_email_pattern(email) {
    var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    if (email !== "") {
        if (!pattern.test(email)) {
            return true;
        } else {
            return false;
        }
    } else return true;
}

function Update_serv_modal({ update_service, setupdate_service, setUrl_updated, departments, available_habilitations }) {

    const [errorText, setErrorText] = useState(null);

    const [update_password, setUpdate_password] = useState(false);
    const [is_manager, setis_manager] = useState(update_service.is_manager);

    const [full_name, setFull_name] = useState(update_service.fullName);
    const [email, setEmail] = useState(update_service.email);
    const [role, setRole] = useState(update_service.role);
    const [habilitation, setHabilitation] = useState(update_service.habilitation);

    const [cnss, setcnss] = useState(update_service.cnss);
    const [country, setcountry] = useState(update_service.country);
    const [city, setcity] = useState(update_service.city);
    const [address, setaddress] = useState(update_service.address);
    const [postcode, setpostcode] = useState(update_service.postcode);
    const [tele, setTele] = useState(update_service.phoneNumber);
    const [department, setDepartment] = useState(update_service.department ? update_service.department : "");


    const [signature_file, setSignature_file] = useState(null);

    const [waiting, setWaiting] = useState(false)

    function submit() {
        setErrorText(null);
        if (email === "" || full_name === "" || role === "null" || habilitation === "null" || department === "") {
            setErrorText("Champs invalides !");
        } else {
            if (invalid_email_pattern(email)) {
                setErrorText("Email invalid !");
            } else {
                swal({
                    title: "Etes-vous sûr ?",
                    text: "!!!",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            setWaiting(true);
                            let formData = new FormData();
                            formData.append('id', update_service.id);
                            formData.append('fullName', full_name);
                            formData.append('prev_email', update_service.email);
                            formData.append('email', email);
                            formData.append('country', country);
                            formData.append('cnss', cnss);
                            formData.append('city', city);
                            formData.append('address', address);
                            formData.append('postcode', postcode);
                            formData.append('phoneNumber', tele);
                            formData.append('department', department);
                            formData.append('is_manager', is_manager ? 1 : 0);
                            formData.append('role', role);
                            formData.append('habilitation', habilitation);
                            formData.append('signature_file', signature_file);
                            formData.append('update_password', update_password ? 1 : 0);
                            update_service_req(formData).then((response) => {
                                setWaiting(false);
                                swal("Le service a été modifiée avec succès ! " + (response.data.mdp ? "\n Mot de passe : " + response.data.mdp : ""), {
                                    icon: "success",
                                    buttons: true,
                                }).then((willDelete) => {
                                    if (willDelete) {
                                    }
                                })
                                setupdate_service(null);
                                setUrl_updated(response.data);
                               //  console.log(response.data);
                            }).catch((error) => {
                                //console.log(error.response);
                                let error_data = error.response.data;
                                if (error_data.errors) {
                                    if (error_data.errors.email) setErrorText("Email déjà existant !");
                                    if (error_data.errors.phoneNumber) setErrorText("Téléphone déjà existant !");
                                }
                                setWaiting(false);
                            });
                        }
                    })
            }
        }
    }

    async function upload_user_signature(file) {
        setSignature_file(file);
    }

    return (
        <Dialog fullWidth={true} maxWidth={'md'} open={update_service ? true : false} onClose={() => setupdate_service(null)} aria-labelledby="form-dialog-title" >
            <DialogTitle id="form-dialog-title">Modifier les infos</DialogTitle>
            <DialogContent>
                <div className="add_services_form" style={{ width: '95%' }}>
                    <Row className="mb-12">
                        <Form.Group className="col-md-6">
                            <label>Nom complet *</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="Nom *"
                                value={full_name}
                                onChange={e => { setFull_name(e.target.value) }}
                                className={errorText && full_name === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Rôle *</label>
                            <Form.Select
                                required
                                value={role}
                                onChange={e => {
                                    setRole(e.target.value);
                                }}
                                className={errorText && role === "null" ? "is-invalid" : ""}
                                name="categorie"
                            >
                                <option value={"null"} disabled selected>Rôle</option>
                                <option value={1}>{"service d'achat"}</option>
                                <option value={2}>{"service métier"}</option>
                                <option value={3}>{"service de finance"}</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Email *</label>
                            <InputGroup hasValidation>
                                <Form.Control
                                    required
                                    autoComplete="new-password"
                                    type="text"
                                    placeholder="E-mail *"
                                    value={email}
                                    onChange={e => { setEmail(e.target.value); }}
                                    className={errorText && invalid_email_pattern(email) ? "is-invalid" : ""}
                                />
                                <InputGroup.Text className={errorText && invalid_email_pattern(email) ? "invalid-inputgroup" : "valid-inputgroup"}>
                                    <FontAwesomeIcon icon={faEnvelope} />
                                </InputGroup.Text>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Département *</label>
                            <Form.Select
                                required
                                value={department}
                                onChange={e => {
                                    setDepartment(e.target.value);
                                }}
                                className={errorText && department === "" ? "is-invalid" : ""}
                                name="departement"
                            >
                                <option value={""} disabled>Département</option>
                                {
                                    departments.map((dep) => (
                                        <option key={"dep" + dep.id} value={dep.id}>{dep.title}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="col-md-6">
                                <label>Habilitation *</label>
                                <Form.Select
                                    required
                                    value={habilitation}
                                    onChange={e => {
                                        setHabilitation(e.target.value);
                                    }}
                                    className={errorText && role === "null" ? "is-invalid" : ""}
                                    name="habilitation"
                                >
                                    <option value={"null"} disabled selected>Habilitation</option>
                                    {
                                        available_habilitations.map((hab) => (
                                            <option key={"habil_" + hab.id} value={hab.id}>{hab.role_title}</option>
                                        ))
                                    }
                                </Form.Select>
                            </Form.Group>
                        <Form.Group className='col-md-6'>
                            <FormControlLabel
                                label="Manager"
                                control={
                                    <Checkbox
                                        checked={is_manager}
                                        onChange={(e) => setis_manager(e.target.checked)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                } />
                        </Form.Group>
                    </Row>
                    <Row className="mb-12">

                        <Form.Group className="col-md-6">
                            <label>cnss</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="cnss *"
                                value={cnss}
                                onChange={e => { setcnss(e.target.value) }}
                                className={errorText && cnss === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Téléphone</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="Téléphone *"
                                value={tele}
                                onChange={e => { setTele(e.target.value) }}
                                className={errorText && tele === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Pays</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="Pays*"
                                value={country}
                                onChange={e => { setcountry(e.target.value) }}
                                className={errorText && country === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Ville</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="Ville *"
                                value={city}
                                onChange={e => { setcity(e.target.value) }}
                                className={errorText && city === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>address</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="address *"
                                value={address}
                                onChange={e => { setaddress(e.target.value) }}
                                className={errorText && address === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Code postal</label>
                            <Form.Control
                                required
                                autoComplete="new-password"
                                type="text"
                                placeholder="Code postal *"
                                value={postcode}
                                onChange={e => { setpostcode(e.target.value) }}
                                className={errorText && postcode === "" ? "is-invalid" : ""}
                            />
                        </Form.Group>

                        <Form.Group className="col-md-6">
                            <label>Signature</label>
                            <input style={{ display: "none", marginTop: "12px" }} accept=".jpg,.png,.jpeg" name="profil_img" id="profil_img" multiple type="file" onChange={(e) => upload_user_signature(e.target.files[0])} />
                            <label htmlFor="profil_img">
                                <span className="submit_but edit_but"  >
                                    <EditIcon className="my_icon" /> Importer la signature
                                </span>
                                {signature_file != null ? "(Fichier importé)" : (update_service.signature ? "(Signature associée)" : "")}
                            </label>
                        </Form.Group>
                        <Form.Group className='col-md-6'>
                            <FormControlLabel
                                label="Générer un nouveau mot de passe"
                                control={
                                    <Checkbox
                                        checked={update_password}
                                        onChange={(e) => setUpdate_password(e.target.checked)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                } />
                        </Form.Group>
                    </Row>
                </div>

            </DialogContent>
            <DialogActions>
                <div className='dialogBottom'>
                    <div>
                        {
                            errorText === ""
                                ? <></>
                                : <p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                                    {errorText}
                                </p>
                        }
                    </div>
                    <div>
                        <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={() => setupdate_service(null)} >
                            Annuler
                        </Button>
                        <Button variant="contained" className="submit_but valide_but" startIcon={<EditIcon />} onClick={submit} >
                            Modifier
                        </Button>
                    </div>

                </div>
            </DialogActions>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

        </Dialog>
    )
}

export default Update_serv_modal
